import { UserDataUpdate } from "../../types/authTypes";
import { Image, NewShirt } from "../shirts/types";
import {
  postCall,
  getCall,
  putCall,
  patchCall,
  HeadersInterface,
  BodyParamsInterface,
  convertInterfaceToBodyParams,
  QueryParamsInterface,
  deleteCall,
} from "./api";

const BASE_URL = "v1/users";
const NETWORKS_URL = "v1/networks";

export const searchUsers = async (
  text: string | undefined,
  pageNum?: number,
  pageSize?: number
) => {
  let url = BASE_URL + "/search";
  let headers: HeadersInterface | undefined;

  let params: string[] = [];
  if (text) params.push("q=" + encodeURIComponent(text));
  if (pageNum !== undefined) params.push("page=" + pageNum);
  if (pageSize !== undefined) params.push("perPage=" + pageSize);

  let queryString = params.length > 0 ? params.join("&") : undefined;

  let response = await getCall(url, headers, queryString);

  return response;
};

export const updateProfileImage = async (image: Image) => {
  let url = BASE_URL + "/image/profile";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    image: image,
  });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const updateHeaderImage = async (image: Image) => {
  let url = BASE_URL + "/image/header";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    image: image,
  });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const updatePassword = async (
  current: string,
  password: string,
  confirmation: string
) => {
  let url = BASE_URL + "/me/password";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    password_current: current,
    password: password,
    password_confirmation: confirmation,
  });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const updateEmail = async (email: string) => {
  let url = BASE_URL + "/me/email";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    email: email,
  });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const updateAboutMe = async (about: string) => {
  let url = BASE_URL + "/me/account";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    about_me: about,
  });
  let response = await patchCall(url, headers, undefined, body);

  return response;
};

export const updateMyDetails = async (details: UserDataUpdate) => {
  let url = BASE_URL + "/me/details";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams(details);
  let response = await patchCall(url, headers, undefined, body);

  return response;
};

export const updateCollectionPrivacy = async (isPrivate: boolean) => {
  let url = "v1/collections/update/privacy";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    private: isPrivate,
  });
  let response = await patchCall(url, headers, undefined, body);

  return response;
};

export const updateCollectionFinancialStatsPrivacy = async (
  isPublic: boolean
) => {
  let url = BASE_URL + "/me/stats";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    view_finacial_stats: isPublic,
  });
  let response = await patchCall(url, headers, undefined, body);

  return response;
};

export const updateCollectionNumericStatsPrivacy = async (
  isPublic: boolean
) => {
  let url = BASE_URL + "/me/stats";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    view_numerical_stats: isPublic,
  });
  let response = await patchCall(url, headers, undefined, body);

  return response;
};

export const getUserDetails = async (userId: number) => {
  let url = BASE_URL + "/" + userId;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getSocialNetworks = async () => {
  let url = NETWORKS_URL;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const updateSocialNetworks = async (snId: number, snUrl: string) => {
  let url = NETWORKS_URL + "/" + snId;
  let headers: HeadersInterface | undefined;
  let body: BodyParamsInterface = convertInterfaceToBodyParams({ url: snUrl });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const removeSocialNetworks = async (snId: number) => {
  let url = NETWORKS_URL + "/" + snId;
  let headers: HeadersInterface | undefined;

  let response = await deleteCall(url, headers);

  return response;
};
